import React, { useEffect, useRef, useState } from "react";
import logobig from "../Asset/navbar/logobig.png";
import { MdLanguage } from "react-icons/md";
import { FaUserAlt } from "react-icons/fa";
import { IoSearch } from "react-icons/io5";
import { GiHamburgerMenu } from "react-icons/gi";
import Login from "./login/Login";
import Signup from "./signup/Signup";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "../lib/helper";
import { FaChevronDown } from "react-icons/fa";
import { BsShieldFillExclamation } from "react-icons/bs";
import { MdOutlinePrivacyTip } from "react-icons/md";
import { IoAlertCircleOutline } from "react-icons/io5";
import { GoShieldCheck } from "react-icons/go";
import { MdOutlineWallet } from "react-icons/md";
import { CiLogin } from "react-icons/ci";
import { CiLogout } from "react-icons/ci";
import EditUser from "./edituser/Edituser";
import { BsFillClipboard2CheckFill } from "react-icons/bs";
import AddressView from "./addressview/AddressView";
import { FaMapMarkerAlt } from "react-icons/fa";
import { useContact } from "../useContext/ContactContext";
import { ImHome3 } from "react-icons/im";
import { FaShoppingCart } from "react-icons/fa";
import { MdBorderColor } from "react-icons/md";
import AOS from "aos";
import "aos/dist/aos.css";
import { GoHomeFill } from "react-icons/go";
import { HiMiniWallet } from "react-icons/hi2";
import { BsFillInfoCircleFill } from "react-icons/bs";
import { FaLocationDot } from "react-icons/fa6";
import { FaSignOutAlt } from "react-icons/fa";
import { FaBoxOpen } from "react-icons/fa6";
import { FaCartShopping } from "react-icons/fa6";
import categoryModel from "../model/category.model";
import login from "../Asset/toast/login.png";

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(true);
  const [signup, setSignup] = useState(false);
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [editstatus, setEditstatus] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const [viewaddress, setViewAddress] = useState(false);
  const { search, setSearch, userdata, GetUser } = useContact();
  useEffect(() => {
    const token = sessionStorage.getItem("token");
    setIsLoggedIn(!!token);
  }, []);
  const menuRef = useRef(null);
  const handleLogout = () => {
    setShowDropdown(false);
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("user");
    setIsLoggedIn(false);
    window.location.reload();
  };

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const user = JSON.parse(sessionStorage.getItem("user"));

  // useEffect(() => {
  // if (!search) {
  //  navigate(`/`);
  // } else {
  //  navigate(`/searchproduct/${search}`);
  // }
  //}, [search]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    AOS.init();
  }, []);

  const [categoryproduct, setCategoryproduct] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [loading, setLoading] = useState(false);
  const containerRef = useRef(null);
  const clickedSuggestionRef = useRef(false);

  const handleChange = async () => {
    setCategoryproduct([]);

    // Skip fetch if a suggestion was clicked
    if (clickedSuggestionRef.current) {
      clickedSuggestionRef.current = false;
      return;
    }

    if (search) {
      setLoading(true);
      try {
        const response = await categoryModel.GetSearch(search);
        setCategoryproduct(response?.data?.data || []);
        setShowSuggestions(true);
        console.log("Fetched data:", response);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    } else {
      setShowSuggestions(false);
      setCategoryproduct([]);
    }
  };

  const handleSuggestionClick = (name, id) => {
    clickedSuggestionRef.current = true;
    setSearch(name);
    setShowSuggestions(false);
    navigate(`/productdetail/${id}`);
  };

  useEffect(() => {
    handleChange();
  }, [search]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <>
      <div className="w-full  h-20">
        <div
          className="w-full bg-Background1 h-full shadow-lg flex items-center justify-between px-2 lg:px-7 xl:px-10
  rounded-b-3xl rounded-t-none 
  md:rounded-b-4xl md:rounded-t-4xl"
        >
          <div className="flex gap-4 items-center bg-Background1">
            <div
              className="w-36 cursor-pointer"
              onClick={() => {
                navigate("/");
              }}
            >
              <img src={logobig} className="w-full" alt="" />
            </div>
            {/*<div className="hidden md:flex gap-3 bg-Background2 px-2 py-1.5 rounded-4xl items-center ">
              <div className="bg-textColor w-6 h-6 rounded-full flex items-center justify-center text-lg text-white">
                <MdLanguage />
              </div>
              <span className="text-textColor text-base font-bold mr-3">
                Location
              </span>
            </div>*/}
          </div>
          <div className="flex gap-2 lg:gap-4 items-center">
            <div
              className="sm:hidden flex text-3xl text-textColor relative cursor-pointer"
              ref={menuRef}
            >
              <GiHamburgerMenu onClick={() => setIsOpen(!isOpen)} />
              {isOpen && (
                <div
                  data-aos="fade-left"
                  className=" w-full h-[68px] fixed top-20 inset-0 bg-black/60 flex justify-center   z-50 rounded-xl p-4
                "
                >
                  <ul className="flex  gap-2 text-center w-full ">
                    <li
                      className="flex items-center justify-center gap-2   bg-gray-400 text-white w-full rounded-2xl text-base"
                      onClick={() => {
                        navigate("/");
                        setSearch("");
                        setIsOpen(!isOpen);
                      }}
                    >
                      <GoHomeFill /> Home
                    </li>
                    <li
                      className="flex items-center justify-center gap-2   bg-gray-400 text-white w-full rounded-2xl text-base"
                      onClick={() => {
                        navigate("/cart");
                        setSearch("");
                        setIsOpen(!isOpen);
                      }}
                    >
                      <FaCartShopping />
                      Cart
                    </li>
                    <li
                      className="flex items-center justify-center gap-2  bg-gray-400 text-white w-full  rounded-2xl text-base"
                      onClick={() => {
                        navigate("/order");
                        setSearch("");
                        setIsOpen(!isOpen);
                      }}
                    >
                      <FaBoxOpen />
                      Order
                    </li>
                  </ul>
                </div>
              )}
            </div>
            <div className="sm:flex items-center gap-10 hidden ">
              <span
                className={`text-base font-bold cursor-pointer transform transition duration-100 hover:scale-105 flex items-center gap-1 ${
                  location.pathname == "/"
                    ? "text-gray-700 scale-105 "
                    : "text-textColor hover:text-gray-700 "
                }`}
                onClick={() => {
                  navigate("/");
                }}
              >
                <GoHomeFill /> Home
              </span>
              <span
                className={`text-base font-bold cursor-pointer transform transition duration-100 hover:scale-105 flex items-center gap-1 ${
                  location.pathname == "/order"
                    ? "text-gray-700 scale-105"
                    : "text-textColor hover:text-gray-700"
                }`}
                onClick={() => {
                  const token = sessionStorage.getItem("token");
                  if (token) {
                    navigate("/order");
                  } else {
                    toast("Please login first", login);
                    //   setShowLoginPopup(true);
                  }
                }}
              >
                <FaBoxOpen /> Order
              </span>
              <span
                className={`text-base font-bold cursor-pointer transform transition duration-100 hover:scale-105 flex gap-1 items-center ${
                  location.pathname == "/cart"
                    ? "text-gray-700 scale-105"
                    : "text-textColor hover:text-gray-700"
                }`}
                onClick={() => {
                  const token = sessionStorage.getItem("token");
                  if (token) {
                    navigate("/cart");
                  } else {
                    toast("Please login first", login);
                    // setShowLoginPopup(true);
                  }
                }}
              >
                <FaCartShopping /> Cart
              </span>
            </div>
            <div className="flex gap-2 lg:gap-3 items-center">
              <div className="relative w-full max-w-md" ref={containerRef}>
                <div
                  className={`bg-Background3 border hidden md:flex gap-2 items-center rounded-4xl px-3 transition-all duration-300 ${
                    search?.length > 0 ? "lg:w-72" : "lg:w-56"
                  } w-48`}
                >
                  <IoSearch className="text-lg lg:text-xl" />
                  <input
                    type="text"
                    placeholder="Search items"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="bg-inherit py-2.5 outline-none focus:ring-0 w-full"
                  />
                </div>

                {/* Loading state */}
                {showSuggestions && loading && (
                  <div className="absolute mt-1 w-full bg-white text-sm text-gray-500 border border-gray-300 rounded-xl shadow-md px-4 py-2">
                    Loading...
                  </div>
                )}

                {/* No results found */}
                {showSuggestions &&
                  !loading &&
                  categoryproduct?.length === 0 && (
                    <div className="absolute mt-1 w-full bg-white text-sm text-gray-500 border border-gray-300 rounded-xl shadow-md px-4 py-2">
                      No results found.
                    </div>
                  )}

                {/* Suggestions list */}
                {showSuggestions && categoryproduct?.length > 0 && (
                  <ul className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded-xl shadow-lg text-sm overflow-y-auto max-h-60">
                    {categoryproduct?.map((item, index) => (
                      <li
                        key={index}
                        className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                        onClick={() =>
                          handleSuggestionClick(item?.name, item?._id)
                        }
                      >
                        {item.name}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              <div className="flex gap-2 lg:gap-3 bg-textColor px-2 py-1 rounded-4xl items-center">
                <div className="bg-Background2 w-8 h-8 rounded-full flex items-center justify-center text-base text-textColor">
                  {user ? (
                    <img
                      src={userdata?.data?.profile_pic_link}
                      alt="img"
                      className="rounded-full border-2 border-white w-full h-full object-cover cursor-pointer"
                      onClick={() => {
                        setEditstatus(true);
                      }}
                    />
                  ) : (
                    <FaUserAlt />
                  )}
                </div>
                {isLoggedIn ? (
                  <button className=" text-white px-1 py-2 rounded">
                    <span className="text-white text-base font-bold mr-3 hover:text-gray-300">
                      {user && userdata?.data?.name?.split(" ")[0]}
                    </span>
                  </button>
                ) : (
                  <button
                    className=" text-white px-1 py-2 rounded"
                    onClick={() => {
                      setShowLoginPopup(true);
                      setShowDropdown(false);
                    }}
                  >
                    <span className="text-white text-base font-bold mr-3">
                      Login
                    </span>
                  </button>
                )}
                {user && (
                  <FaChevronDown
                    className={`mr-3 text-white cursor-pointer `}
                    ref={dropdownRef}
                    onClick={() => setShowDropdown((prev) => !prev)}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {showDropdown && (
        <div
          className="absolute right-4 mt-2 w-56 bg-white shadow-lg  z-50 rounded-xl"
          ref={dropdownRef}
        >
          <ul className="py-2">
            {isLoggedIn && (
              <>
                <li
                  className="px-5 py-3 hover:bg-gray-100 cursor-pointer "
                  onClick={() => {
                    setEditstatus(true);
                    setShowDropdown(false);
                  }}
                >
                  <div className="flex gap-4 items-center">
                    <FaUserAlt className=" text-lg text-textColor" />
                    <span>Profile</span>
                  </div>{" "}
                </li>
              </>
            )}

            <li
              className={`px-5 py-3 hover:bg-gray-100 ${
                location?.pathname == "/privacy"
                  ? "cursor-not-allowed"
                  : "cursor-pointer"
              }  `}
              onClick={() => {
                navigate("/privacy");
                setShowDropdown(false);
              }}
            >
              <div className="flex gap-4 items-center">
                {" "}
                <BsShieldFillExclamation className=" text-lg text-textColor" />
                <span> Privacy Policy</span>
              </div>
            </li>
            <li
              className={`px-5 py-3 hover:bg-gray-100 ${
                location?.pathname == "/termandcondion"
                  ? "cursor-not-allowed"
                  : "cursor-pointer"
              } `}
              onClick={() => {
                navigate("/termandcondion");
                setShowDropdown(false);
              }}
            >
              <div className="flex gap-4 items-center">
                {" "}
                <BsFillClipboard2CheckFill className=" text-lg text-textColor" />
                <span> Term and Condition</span>
              </div>
            </li>
            <li
              className={`px-5 py-3 hover:bg-gray-100 ${
                location?.pathname == "/about"
                  ? "cursor-not-allowed"
                  : "cursor-pointer"
              } `}
              onClick={() => {
                navigate("/aboutus");
                setShowDropdown(false);
              }}
            >
              <div className="flex gap-4 items-center">
                {" "}
                <BsFillInfoCircleFill className=" text-lg text-textColor" />
                <span> About Us</span>
              </div>
            </li>

            {isLoggedIn ? (
              <>
                <li
                  className={`px-5 py-3 hover:bg-gray-100 ${
                    location?.pathname == "/wallet"
                      ? "cursor-not-allowed"
                      : "cursor-pointer"
                  } `}
                  onClick={() => {
                    navigate("/wallet");
                    setShowDropdown(false);
                  }}
                >
                  <div className="flex gap-4 items-center">
                    {" "}
                    <HiMiniWallet className=" text-lg text-textColor" />
                    <span> Wallet</span>
                  </div>
                </li>

                <li
                  className={`px-4 py-2 hover:bg-gray-100 ${
                    location?.pathname == "/addaddresss"
                      ? "cursor-not-allowed"
                      : "cursor-pointer"
                  } `}
                  onClick={() => {
                    setViewAddress(true);
                    setShowDropdown(false);
                  }}
                >
                  <div className="flex gap-4 items-center">
                    {" "}
                    <FaLocationDot className=" text-xl text-textColor ml-1" />
                    <span> Address</span>
                  </div>
                </li>
                <li
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                  onClick={handleLogout}
                >
                  <div className="flex gap-4 items-center">
                    <FaSignOutAlt className=" text-lg ml-2 text-textColor" />
                    <span> Logout</span>
                  </div>
                </li>
              </>
            ) : (
              <li
                className="px-5 py-3 hover:bg-gray-100 cursor-pointer"
                onClick={() => {
                  setShowLoginPopup(true);
                  setShowDropdown(false);
                }}
              >
                <div className="flex gap-2 items-center">
                  <CiLogin className=" text-lg text-textColor" />

                  <span> Login</span>
                </div>
              </li>
            )}
          </ul>
        </div>
      )}
      {showLoginPopup && (
        <Login
          setShowLoginPopup={setShowLoginPopup}
          setSignup={setSignup}
          setIsLoggedIn={setIsLoggedIn}
        />
      )}
      {signup && <Signup setSignup={setSignup} />}
      {editstatus && (
        <EditUser setEditstatus={setEditstatus} editstatus={editstatus} />
      )}
      {viewaddress && (
        <AddressView
          viewaddress={viewaddress}
          setViewAddress={setViewAddress}
        />
      )}
    </>
  );
};

export default Navbar;
